
import ImgCarousel from "../ImgCarousel/ImgCarousel";
import ServicesSmall from "../ServicesSmall/ServicesSmall";
import ContactAndAbout from "../ContactAndAbout/ContactAndAbout";
import ChooseUs from "../ChooseUs/ChooseUs";
import AboutUs from "../AboutUsMain/AboutUsMain";
import ContactAndMap from "../ContactAndMap/ContactAndMap";
import Services from "../Services/Services";
import React from "react";
import { Helmet } from 'react-helmet';

function HomePage() {
  return (
    <>
      <Helmet>
        <title>East Village Landscaping - Springfield, MA</title>
        <meta
          name="description"
          content="The official website of East Village Lanscaping - Located in Springfield, MA. We serve all of your outdoor needs. Call us at 413-736-5168 to request a quote and book a service"
        />
        <meta property="og:title" content="East Village Landscaping - Springfield, MA" />
        <meta property="og:description" content="The official website of East Village Lanscaping - Located in Springfield, MA. We serve all of your outdoor needs. Call us at 413-736-5168 to request a quote and book a service" />
        {/*<meta property="og:image" content={URL of the image you want to use} />*/}
        <meta property="og:url" content="www.eastvillagelandscaping.com" />
        <meta property="og:type" content="website" />
      </Helmet>
      <ImgCarousel></ImgCarousel>
      <ServicesSmall></ServicesSmall>
      <ContactAndAbout></ContactAndAbout>
      <ChooseUs></ChooseUs>
    </>
  );
}

function AboutUsPage() {
  return (
    <>
      <Helmet>
        <title>East Village Landscaping - Springfield, MA - About Us</title>
        <meta
          name="description"
          content="The official website of East Village Lanscaping - Located in Springfield, MA. A brief description about our business"
        />
        <meta property="og:title" content="East Village Landscaping - Springfield, MA" />
        <meta property="og:description" content="The official website of East Village Lanscaping - Located in Springfield, MA. A brief description of all the services we provide" />
        {/*<meta property="og:image" content={URL of the image you want to use} />*/}
        <meta property="og:url" content="www.eastvillagelandscaping.com/about" />
        <meta property="og:type" content="website" />
      </Helmet>
      <AboutUs></AboutUs>
      <ContactAndMap></ContactAndMap>
      <ChooseUs></ChooseUs>
    </>
  );
}

function ServicesPage() {
  return (
    <>
    <Helmet>
        <title>East Village Landscaping - Springfield, MA - Services</title>
        <meta
          name="description"
          content="The official website of East Village Lanscaping - Located in Springfield, MA. A brief description of our services"
        />
        <meta property="og:title" content="East Village Landscaping - Springfield, MA" />
        <meta property="og:description" content="The official website of East Village Lanscaping - Located in Springfield, MA. A brief description of our services" />
        {/*<meta property="og:image" content={URL of the image you want to use} />*/}
        <meta property="og:url" content="www.eastvillagelandscaping.com/services" />
        <meta property="og:type" content="website" />
      </Helmet>
      <Services></Services>
      <ImgCarousel></ImgCarousel>
      <ContactAndAbout bgVariant={1}></ContactAndAbout>
    </>
  );
}

export { HomePage, AboutUsPage, ServicesPage };
